import { Pipe, PipeTransform } from '@angular/core';
import {CustomerDto, UserListDto} from '@shared/service-proxies/service-proxies';

@Pipe({
    name: 'fullName'
})
export class FullNamePipe implements PipeTransform {
    transform(user: CustomerDto | UserListDto | undefined): string {
        if (!user) {
            return ''; // Return an empty string if user is undefined
        }

        let firstName = '';
        if ('firstName' in user) {
            firstName = user.firstName || '';
        } else if ('name' in user) {
            firstName = user.name || '';
        }

        // Combine 'name' and 'surname' to create full name
        const fullName = `${firstName} ${user.surname || ''}`.trim();
        return fullName;
    }
}
